import { render } from "./WirePayment.vue?vue&type=template&id=02e36b96&lang=pug"
import script from "./WirePayment.vue?vue&type=script&lang=js"
export * from "./WirePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__